import { useCallback, useRef } from "react";

interface IProps {
  storedBatchId: number | null;
  selectedBatchId: number | null;
}

// Keeps the initial auto-search from firing until the restored batch selection
// is applied, so processedAt and batchId stay in sync after a refresh.
export const useBatchSync = ({ storedBatchId, selectedBatchId }: IProps) => {
  const hasSyncedStoredBatchRef = useRef(!storedBatchId);

  // Ready only after the stored batch is selected and its change handler ran.
  const isReadyForInitialSearch =
    (!storedBatchId || selectedBatchId === storedBatchId) &&
    hasSyncedStoredBatchRef.current;

  // Re-arm the sync gate when the stored batch changes.
  const resetBatchSync = useCallback(() => {
    hasSyncedStoredBatchRef.current = !storedBatchId;
  }, [storedBatchId]);

  // Call this from the batch date change handler to unlock the initial search.
  const markBatchSynced = useCallback(
    (batchId?: number | null) => {
      if (!storedBatchId || batchId === storedBatchId) {
        hasSyncedStoredBatchRef.current = true;
      }
    },
    [storedBatchId]
  );

  return {
    isReadyForInitialSearch,
    resetBatchSync,
    markBatchSynced,
  };
};
